import {HojasCallCenterComponent} from "../hojas-call-center.component";
import {Campas} from "../models/Campas";
import {ArticuloContact} from "../models/ArticuloContact";

export class CampasFunctions{
  static checkCampa(piloto: string, cliente: string, taller: string, result: Campas[], articulos: ArticuloContact[], formularioHojas: HojasCallCenterComponent){

    //formularioHojas.showCampa = false;

    if(result.length < 1){
      return false;
    }else{
      let reparaciones = this.checkRepa(articulos);
      for (let item of result) {
        if (item.piloto != "" && item.piloto != piloto){
          return  false;
        }
        if (item.cliente != "" && item.cliente != cliente){
          return false;
        }

        if(item.soloRepas && !reparaciones){
          return false
        }

        if(!item.opcional){
          formularioHojas.campanaArticulos = item.articulos;
          return true;
        }else{
          formularioHojas.campanaArticulos = item.articulos;
          formularioHojas.showCampa = true;
          return false;
        }
      }
      return true;
    }
  }

  static checkRepa(articulos: ArticuloContact[]) {
    const artsRepa = new Set(["99000001", "99000010"]);
    return articulos.some(articulo => artsRepa.has(articulo.articulo));
  }
}
